import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

import { computed } from "vue";
import { appStore } from "@/hooks";
import { DetailsPanel, PanelCard } from "@/components/common";
import { TraceLinkGenerator } from "@/components/traceLink/save";


/**
 * Displays trace link information.
 */
const __default__ = {
  name: "TraceLinkPanel",
};

export default /*#__PURE__*/_defineComponent({
  ...__default__,
  setup(__props) {

const isOpen = computed(() => appStore.popups.detailsPanel === "generateTrace");

/**
 * Closes all side panels.
 */
function handleClose(): void {
  appStore.closeSidePanels();
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(_unref(DetailsPanel), {
    panel: "generateTrace",
    "data-cy": "panel-trace-display"
  }, {
    default: _withCtx(() => [
      _createVNode(_unref(PanelCard), {
        title: "Generate Trace Links",
        borderless: ""
      }, {
        default: _withCtx(() => [
          _createVNode(_unref(TraceLinkGenerator), {
            open: isOpen.value,
            onSubmit: handleClose
          }, null, 8, ["open"])
        ]),
        _: 1
      })
    ]),
    _: 1
  }))
}
}

})